import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { useRestClient } from '@/contexts/QueryProvider'
import { useSessionStorage } from '@/hooks'
import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { isPlatformAdmin, isSuperUser } from '@/util'
import { Suspense } from 'react'
import { SubscriptionsBreadcrumb } from '../SubscriptionBreadcrumbs'
import { useCurrentOrganisation } from '../useCurrentOrganisation'
import { DefaultTokenLimitSection } from './DefaultTokenLimitSection'
import { TokenLimitOverridesSection } from './TokenLimitOverridesSection'

export function OrganisationTokenLimitsPage() {
  return (
    <>
      <SubscriptionsBreadcrumb title="Token limits" />
      <QueryErrorBoundary errorMessage="Failed to fetch token limits">
        <Suspense fallback={<LoadingComponent className="flex-1" />}>
          <TokenLimitsContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function TokenLimitsContent() {
  const { id: orgId } = useCurrentOrganisation()
  const [userRole] = useSessionStorage('roles', 1)
  const [sub] = useSessionStorage('sub', '')
  const {
    getSubscriptionsApiGetOrganisationTokenLimits,
    getSubscriptionsApiListOrganisationUsers,
    getSubscriptionsApiListOrganisationPlatformAdmins,
  } = useRestClient()

  const { data: tokenLimits } = getSubscriptionsApiGetOrganisationTokenLimits.useSuspenseQuery({
    path: { orgId },
  })
  const { data: organisationUsers } = getSubscriptionsApiListOrganisationUsers.useSuspenseQuery({
    query: { orgId },
  })
  const { data: currentAdmins } = getSubscriptionsApiListOrganisationPlatformAdmins.useSuspenseQuery({
    query: { organisationId: orgId },
  })

  const canEdit =
    isSuperUser(userRole) ||
    (isPlatformAdmin(userRole) && currentAdmins?.some((admin) => admin.id.toString() === sub))

  return (
    <SectionLayout>
      <DefaultTokenLimitSection defaultLimitUsd={tokenLimits.defaultLimitUsd} canEdit={canEdit} />
      <TokenLimitOverridesSection
        userLimits={tokenLimits.userLimits ?? []}
        organisationUsers={organisationUsers}
        canEdit={canEdit}
      />
    </SectionLayout>
  )
}
